formatCheckoutOrder